import React, { useState } from "react";
import { FormControl, FormGroup, TextField } from "@mui/material";
import { InputLabel } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { repeatEventType } from "../Add-Calendar-Event-Modal";
import { submitListType } from "../ScheduleEventForm";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

type propsType = {
  repeatEvent: repeatEventType;
  submitOptionList: submitListType[];
  setRepeatEvent: React.Dispatch<React.SetStateAction<repeatEventType>>;
};

export default function SelectRepeat({
  submitOptionList,
  setRepeatEvent,
  repeatEvent,
}: propsType) {
  const [repeatTimes, setRepeatTimes] = useState<number>(0);
  function handleChange(data: any) {
    setRepeatEvent({
      repeatOn: data?.target?.value,
      repeatDays: [...repeatEvent.repeatDays],
    });
  }

  function convertToNumber(dayString: string) {
    switch (dayString) {
      case "Sunday":
        return 0;
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      default:
        return -1;
    }
  }

  function handleDayChange(e: any) {
    let dayNumber = convertToNumber(e.target.value);
    if (e.target.checked) {
      if (!repeatEvent.repeatDays?.includes(dayNumber.toString())) {
        let repeatEventCopy = { ...repeatEvent };
        repeatEventCopy.repeatDays.push(dayNumber);
        setRepeatEvent(repeatEventCopy);
      }
    } else {
      let repeatEventCopy = { ...repeatEvent };
      repeatEventCopy.repeatDays = repeatEventCopy.repeatDays.filter(
        (dayNum) => {
          if (!(+dayNum === +dayNumber)) return true;
          else return false;
        }
      );
      setRepeatEvent(repeatEventCopy);
    }
  }
  function renderMenus() {
    return submitOptionList.map((option: any) => {
      return (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      );
    });
  }
  function handleRepeatTimesChange(e:any) {
    setRepeatTimes(e.target.value);
    setRepeatEvent({ ...repeatEvent, repeatDays: [e.target.value] });
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-laberepeatDaysl">Repeat</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={repeatEvent.repeatOn}
        label="repeat"
        onChange={handleChange}
        sx={{ height: "2.4rem" }}
      >
        {renderMenus()}
      </Select>
      {repeatEvent.repeatOn === "repeat-same-day" && (
        <TextField
          label="Number of repeat"
          type="number"
          value={repeatTimes}
          onChange={handleRepeatTimesChange}
          sx={{ my: 2 }}
        />
      )}
      {repeatEvent.repeatOn === "repeat-specific-days" && (
        <FormGroup sx={{ flexDirection: "row", gap: "1px" }}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                onChange={handleDayChange}
                value="Sunday"
              />
            }
            label="S"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Monday"
                onChange={handleDayChange}
              />
            }
            label="M"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Tuesday"
                onChange={handleDayChange}
              />
            }
            label="T"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Wednesday"
                onChange={handleDayChange}
              />
            }
            label="W"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Thursday"
                onChange={handleDayChange}
              />
            }
            label="T"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Friday"
                onChange={handleDayChange}
              />
            }
            label="F"
          />
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                value="Saturday"
                onChange={handleDayChange}
              />
            }
            label="S"
          />
        </FormGroup>
      )}
    </FormControl>
  );
}
